import UpgradeDialog from './src/UpgradeDialog.vue';
import UpgradeDialogModal from './src/UpgradeDialogModal.vue';
import { createApp, type App } from 'vue';
import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';
import { cn, en, jp, tw } from './src/locales';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import { openClueReport } from '../clue-report';
import { usePlg } from '@eureka/shared/edition-upgrade/src/composables/use-plg';

export { UpgradeDialog, UpgradeDialogModal };

const i18n = createI18n({
    legacy: false,
    locale: getCurrentLanguage(),
    fallbackLocale: 'en',
    messages: {
        cn,
        en,
        jp,
        tw,
    },
});

let isFeatureUpgradeDialogOpen = false;

/**
 * 仅供plg用户使用
 * @returns
 */
export const openFeatureUpgradeDialog = async(params?: {eventDetail?: Record<string, any>}) => {
    if (isFeatureUpgradeDialogOpen) { return }
    isFeatureUpgradeDialogOpen = true;
    const { isJPEnv, checkIsLsPlg, getLsPlgRole } = usePlg()
    if (!await checkIsLsPlg()) { return }

    if (isJPEnv.value) {
        openClueReport({
            pkgType: EurekaPackageType.LS_COMMERCIAL,
            version: 'LS_PLG',
        });
        isFeatureUpgradeDialogOpen = false;
        return;
    }

    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const lsPlgRole = await getLsPlgRole()

    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp(UpgradeDialogModal, {
            role: lsPlgRole,
            eventDetail: params?.eventDetail,
            callback: () => {
                resolve(true);
                unmountApp(app);
                isFeatureUpgradeDialogOpen = false;
            },
        });
        app.use(i18n);
        app.mount(div);
    });

    return promise;
}
